import React, { useEffect, useState } from 'react';
import { getTranslation } from '../../../../../utils/translation';
import RangePicker from '../../../../shared/Point/Filters/RangePicker/RangePicker';
import moment from 'moment';
import {
    getCashierPaymentsData,
    getWeeklyBalance,
    printBalanceReportCashier,
} from '../../../../../store/actions/reports';
import { useDispatch, useSelector } from 'react-redux';
import * as types from '../../../../../store/actions/types';
import { BALANCE_REPORTS_FILTER_PERIODS } from '../../../../../constants/defaultValues';

const rangePeriod = BALANCE_REPORTS_FILTER_PERIODS.find(period => period.key === 'range');
const initialPeriod = BALANCE_REPORTS_FILTER_PERIODS[0];

const Filters = () => {
    const dispatch = useDispatch();

    const accountNumber = useSelector(state => state.settings.account?.data?.accountNumber ?? '');
    const { weeklyBalance, cashierPayment } = useSelector(state => state.reports);

    const [selectedPeriod, setSelectedPeriod] = useState(initialPeriod);
    const [dates, setDates] = useState(Object.values(initialPeriod.getRange()));
    const [startDate, endDate] = dates;

    const clearDates = () => {
        setDates([null, null]);
    };

    const clearReportData = () => {
        dispatch({
            type: types.GET_REPORT_WEEKLY_BALANCE,
            payload: null,
        });
        dispatch({
            type: types.SET_CASHIER_PAYMENTS,
            payload: null,
        });
    };

    const clearAll = () => {
        clearDates();
        clearReportData();
    };

    const getReportData = (startDate, endDate) => {
        if (startDate && endDate) {
            dispatch(getWeeklyBalance(startDate, endDate));
            dispatch(getCashierPaymentsData(startDate, endDate));
        }
    };

    const printReportData = () => {
        printBalanceReportCashier({
            issueDate: moment().format('DD/MM/YY HH:mm:ss'),
            cashierCode: accountNumber,
            periodStartDate: moment(startDate).format('DD/MM/YY HH:mm:ss'),
            periodEndDate: moment(endDate).format('DD/MM/YY HH:mm:ss'),
            periodType: selectedPeriod.periodType,
            ...weeklyBalance,
            total: { ...weeklyBalance.total, ...cashierPayment },
        });
    };

    const onReset = () => {
        clearAll();
        setSelectedPeriod(rangePeriod);
    };

    const onPeriodChange = async period => {
        clearAll();
        setSelectedPeriod(period);

        if (period.key !== rangePeriod.key) {
            const { startTime, endTime } = await period.getRange();
            setDates([startTime, endTime]);
            getReportData(startTime, endTime);
        }
    };

    const handleDateChange = (date, callback) => {
        if (date) {
            clearReportData();
            setSelectedPeriod(rangePeriod);
            callback();
        }
    };

    const onStartDateChange = date => {
        handleDateChange(date, () => {
            setDates(() => [date.getTime(), endDate]);
        });
    };

    const onEndDateChange = date => {
        handleDateChange(date, () => {
            setDates(() => [startDate, date.getTime()]);
        });
    };

    useEffect(() => {
        getReportData(startDate, endDate);
    }, []);

    return (
        <div className={'filters'}>
            <RangePicker
                periods={BALANCE_REPORTS_FILTER_PERIODS}
                selectedPeriod={selectedPeriod}
                onPeriodChange={onPeriodChange}
                startDate={startDate}
                endDate={endDate}
                onStartDateChange={onStartDateChange}
                onEndDateChange={onEndDateChange}
                onSearch={getReportData}
                onReset={onReset}
                showTime
            />
            <div className='m-l-auto' onClick={printReportData}>
                <button className='filter-button'>{getTranslation('print')}</button>
            </div>
        </div>
    );
};

export default Filters;
